export default {
  'WorkOrderTableRowMobile.WorkOrderCard': ({ }, outlet) => {
    outlet({ action: 'open_page' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Unassign': ({ }, outlet) => {
    outlet({ action: 'open_unassign' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Assign': ({ }, outlet) => {
    outlet({ action: 'open_assign' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Part': ({ }, outlet) => {
    outlet({ action: 'open_parts' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Reopen': ({ }, outlet) => {
    outlet({ action: 'open_reopen' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Access': ({ }, outlet) => {
    outlet({ action: 'open_no_access' });
  },
  'WorkOrderTableRowMobile.BackgroundContainer.Cancel': ({ }, outlet) => {
    outlet({ action: 'open_cancel' });
  },

  refreshOn: ({ ref }) => [ref],
  init: ({ ref }, _, internalStateSetter) => {
    setTimeout(() => { swipeFunction({ ref, internalStateSetter }) }, 10);
  }
}

const swipeFunction = ({ ref, internalStateSetter }) => {
  if (!ref?.current) return;

  var xDown = null;
  var yDown = null;
  let swiped = null;

  function getTouches(evt) {
    return evt.touches || evt.originalEvent.touches;
  }

  ref.current.addEventListener('touchstart', function (evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  });

  ref.current.addEventListener("touchend", function (evt) {
    internalStateSetter({ swipe: swiped });
  });
  ref.current.addEventListener('touchmove', function (evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      internalStateSetter({ swipe: (swiped - xDiff) < 0 ? (swiped - xDiff) : 0 });
      if (xDiff > 200) {
        xDown = null;
        yDown = null;
        swiped = -(window.innerWidth - 88)
      } else if (xDiff < -200) {
        xDown = null;
        yDown = null;
        swiped = 0
      }
    }
  });
}